import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=75df3de0&scoped=true&"
import script from "./SiteFooter.vue?vue&type=script&lang=ts&"
export * from "./SiteFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=75df3de0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df3de0",
  null
  
)

export default component.exports